export const DRAWER_OPEN_TIME = 150;
export const DRAWER_CLOSE_TIME = 250;
export const DRAWER_DELAY_OPACITY_TRANSITION_AFTER_CLOSE_TIME =
  DRAWER_CLOSE_TIME / 2;
export const DRAWER_OPACITY_TRANSITION_TIME =
  DRAWER_DELAY_OPACITY_TRANSITION_AFTER_CLOSE_TIME + 50;

export const DRAWER_TRANSITION_DURATION = {
  enter: DRAWER_OPEN_TIME,
  exit: DRAWER_CLOSE_TIME,
};

export const DRAWER_TRANSITION = `all ${DRAWER_OPEN_TIME}ms linear`;
